var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 5C16.7 5 5.5 16.2 5.5 30C5.5 43.8 16.7 55 30.5 55C44.3 55 55.5 43.8 55.5 30C55.5 16.2 44.3 5 30.5 5ZM42.1 22C41.725 25.95 40.1 35.55 39.275 39.975C38.925 41.85 38.225 42.475 37.575 42.55C36.125 42.675 35.025 41.6 33.625 40.675C31.425 39.225 30.175 38.325 28.05 36.925C25.575 35.3 27.175 34.4 28.6 32.95C28.975 32.575 35.375 26.75 35.5 26.225C35.5174 26.1455 35.5151 26.0629 35.4933 25.9845C35.4715 25.9061 35.4309 25.8342 35.375 25.775C35.225 25.65 35.025 25.7 34.85 25.725C34.625 25.775 31.125 28.1 24.3 32.7C23.3 33.375 22.4 33.725 21.6 33.7C20.7 33.675 19 33.2 17.725 32.775C16.15 32.275 14.925 32 15.025 31.125C15.075 30.675 15.7 30.225 16.875 29.75C24.175 26.575 29.025 24.475 31.45 23.475C38.4 20.575 39.825 20.075 40.775 20.075C40.975 20.075 41.45 20.125 41.75 20.375C42 20.575 42.075 20.85 42.1 21.05C42.075 21.2 42.125 21.65 42.1 22Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "homepage/static/media/telegram.150797c59cc7a7ad45e7db367ed6ca57.svg";
export { ForwardRef as ReactComponent };